import { HostListener } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MdbTablePaginationComponent, MdbTableDirective, ModalDirective } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { LocalesModule } from '../../modelo/locales/locales.module';
import { UsuarioModule } from '../../modelo/usuario/usuario.module';
import { LoginService } from '../../servicios/login.service';
import { UsuarioService } from '../../servicios/usuario.service';

@Component({
  selector: 'app-usuario',
  templateUrl: './usuario.component.html',
  styleUrls: ['./usuario.component.css']
})
export class UsuarioComponent implements OnInit {
  usuarios: UsuarioModule[] = [];
  uusuariosActualizar: UsuarioModule[] = [];
  listaUnidadesActulizar: UsuarioModule[] = [];
  searchText: string = '';
  usuario: UsuarioModule;
  editForm: FormGroup;
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective
  @ViewChild('processingModal') public mdbModal: ModalDirective;
  data: UsuarioModule[] = [];
  previous: any = [];
  isLoadingResults = true;
  idLocal:string;
  listaLocales: LocalesModule[];
  constructor(private apiLocal: LoginService, private api:UsuarioService, private alertService: AlertService) { }

  ngOnInit(): void {
    this.usuario=new UsuarioModule();
    this.listar();
   
  }

  @HostListener('input') oninput() {
    this.searchItems();
  }


  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.usuarios = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.usuarios = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }

  listarLocales(id_pais:string)
  {
 

   this.apiLocal.locales(id_pais)
     .subscribe((
       data: LocalesModule[]) => {
       this.listaLocales = data;
       console.log(this.listaLocales);
     },
     err =>  this.alertService.danger('Error no hay  conexion..')
     );
 
  }

  agregar() {
    this.usuario=new UsuarioModule();
    this.usuario.id="0";

    this.mdbModal.show();
  }

  editar(usuarioEdit:UsuarioModule) {
    this.usuario=usuarioEdit;
    this.mdbModal.show();
    this.listarLocales(this.usuario.id_pais.toString())
    this.valueChangePais(this.usuario.id_pais)
    this.valueChange(this.usuario.rol);
    
  }

   valueChange(newValue) {
    this.usuario.rol =newValue;
  
  }
   valueChangePais(newValue) {
    this.usuario.id_pais =newValue;
    this.listarLocales(newValue);
  
  }




  guardar(){


    this.api.guardar(this.usuario).subscribe(

      data  => {
        this.alertService.success("Se actualizo con exito..");
        this.mdbModal.hide();
        this.listar();
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );

  }
  listarCliente() {
    throw new Error('Method not implemented.');
  }


  eliminar(id:number){


    this.api.eliminar(id).subscribe(

      data  => {
        this.alertService.success("Se elimino con exito...");
      
        this.listar();
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );

  }

listar(){
  this.usuarios= [];
  this.api.listarUsuario().subscribe((
    data: UsuarioModule[]) => {
    this.usuarios = data;
    console.log(this.usuarios);
    this.mdbTable.setDataSource(this.usuarios);
    this.mdbTable.dataSourceChange();
    this.previous = this.mdbTable.getDataSource();
  }
    , err => {
      console.log(err);
      this.isLoadingResults = false;
    });
}


}
